<template>
  <b-card class="p-1">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <b-form-group class="w-50 mb-0">
        <b-input-group size="sm">
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="Wyszukaj po tytule, mieście, tagu" />
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''"> Wyczyść </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <div class="d-flex flex-gap">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="btn"
          @click="openOfferBgImageModal">
          Zmień zdjęcie nagłówka
        </b-button>
        <b-button
          :to="{ name: 'job-offers-create' }"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="btn ml-2">
          Dodaj
        </b-button>
      </div>
    </div>
    <b-table
      responsive
      bordered
      striped
      hover
      :items="jobOffers"
      :fields="fields"
      :filter="filter"
      :filter-included-fields="filterOn">
      <template #cell(actions)="row">
        <div class="d-flex flex-column align-items-center">
          <b-button
            :to="{ name: 'job-offers-edit', params: { id: row.item.id } }"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="btn table-btn"
            size="sm">
            Edytuj
          </b-button>
          <b-button class="mt-1 table-btn" variant="danger" size="sm" @click="destroy(row.item)"> Usuń </b-button>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import NotificationMixin from '@/mixins/NotificationMixin';

import { all, destroy, uploadBgImage } from '@/http/job-offers';

export default {
  mixins: [NotificationMixin],

  data() {
    return {
      jobOffers: [],
      filter: '',
      filterOn: [],
      fields: [
        { key: 'title', label: 'Tytuł', sortable: true },
        { key: 'city', label: 'Miasto', sortable: true },
        { key: 'tag', label: 'Tag', sortable: true },
        { key: 'actions', label: 'Akcje' },
      ],
    };
  },

  async mounted() {
    await this.fetchJobOffers();
  },

  methods: {
    async fetchJobOffers() {
      try {
        const { data } = await all({ lang: 'pl' });

        this.jobOffers = data.data;
      } catch (error) {
        this.showErrorNotification(
          'Problem z pobraniem danych',
          'Wystąpił błąd podczas pobierania ofert pracy. Skontaktuj się ze swoim developerem.',
        );
      }
    },
    destroy(jobOffer) {
      this.$swal({
        title: 'Jesteś pewny?',
        text: 'Czy chcesz usunąć ofertę pracy?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Usuń',
        cancelButtonText: 'Anuluj',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          destroy(jobOffer.id)
            .then(() => {
              this.showSuccessNotification('Oferta usunięta', 'Oferta pracy została usunięta.');
              this.fetchJobOffers();
            })
            .catch(() => {
              this.showErrorNotification(
                'Problem z usunięciem oferty',
                'Wystąpił błąd podczas usuwania oferty pracy. Skontaktuj się ze swoim developerem.',
              );
            });
        }
      });
    },
    openOfferBgImageModal() {
      this.$swal({
        title: 'Zdjęcie nagłówkowe',
        html: `
        <div class="import-container">
          <input type="file" v-model="importFile" id="file" class="swal2-file" accept=".jpeg, .jpg, .svg, .png">
        </div>`,
        showCancelButton: true,
        confirmButtonText: 'Dodaj',
        cancelButtonText: 'Anuluj',
        showLoaderOnConfirm: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const file = document.getElementById('file').files[0];
          if (!file) {
            return this.showErrorNotification(
              'Brak pliku',
              'Proszę wybrać poprawny plik do zmiany zdjęcia nagłówkowego.',
            );
          }

          const formData = new FormData();
          formData.append('job_offer_bg_image', file);

          this.uploadBgImg(formData);
        }
      });
    },
    async uploadBgImg(data) {
      await uploadBgImage(data)
        .then(() => {
          this.showSuccessNotification('Zdjęcie zmienione', 'Pomyślnie zmieniono zdjęcie nagłówkowe.');
        })
        .catch(() => {
          this.showErrorNotification('Błąd', 'Wystąpił błąd podczas zmiany zdjęcia nagłówkowego.');
        });
    },
  },
};
</script>

<style lang="scss"></style>
